import { cn } from '@/utils/cn';

export function editorToolButton(active: boolean, disabled: boolean) {
  return cn(
    'flex w-[4.25rem] cursor-pointer flex-col items-center gap-1 rounded-xl border px-1 py-2 text-[10px] font-semibold leading-tight transition-colors lg:w-[4.75rem] lg:text-xs',
    active
      ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
      : 'border-slate-200/80 bg-white text-slate-600 hover:bg-slate-50',
    disabled && 'cursor-not-allowed opacity-40 hover:bg-white',
  );
}

export function editorCommandButton(tone: 'primary' | 'muted', disabled: boolean) {
  return cn(
    'flex w-[4.25rem] cursor-pointer flex-col items-center gap-1 rounded-xl border px-1 py-2 text-[10px] font-semibold leading-tight transition-colors lg:w-[4.75rem] lg:text-xs',
    tone === 'primary'
      ? 'border-emerald-600 bg-emerald-600 text-white shadow-sm shadow-emerald-500/20 hover:bg-emerald-700'
      : 'border-slate-200/80 bg-white text-slate-600 hover:bg-slate-50',
    disabled && 'cursor-not-allowed border-slate-200 bg-slate-50 text-slate-400 opacity-60 shadow-none hover:bg-slate-50',
  );
}

export const toolChipClass =
  'inline-flex h-9 cursor-pointer items-center gap-1.5 rounded-xl border border-slate-200/80 bg-white px-3 text-xs font-semibold text-slate-700 shadow-2xs transition-colors hover:bg-slate-50';

export const toolCancelClass =
  'inline-flex h-9 cursor-pointer items-center justify-center rounded-xl border border-slate-200 bg-white px-4 text-xs font-semibold text-slate-600 transition-colors hover:bg-slate-50';

export const toolApplyClass =
  'inline-flex h-9 cursor-pointer items-center justify-center rounded-xl bg-emerald-600 px-4 text-xs font-semibold text-white shadow-sm shadow-emerald-500/20 transition-colors hover:bg-emerald-700';

export const stageFrameClass =
  'overflow-hidden rounded-xl border border-slate-200/80 bg-white shadow-2xs';
